import { Link } from "@tanstack/react-router";

export type QuickActionProps = {
	icon: React.ComponentType<{ className?: string }>;
	label: string;
	params?: Record<string, string>;
	to?: string;
	onClick?: () => void;
};

export const QuickAction = (props: QuickActionProps) => {
	const { icon: Icon, label, to, params, onClick } = props;
	const content = (
		<div className="flex w-14 shrink-0 flex-col items-center gap-2">
			<div className="flex size-14 items-center justify-center rounded-xl border bg-white shadow-sm">
				<Icon className="size-5" />
			</div>
			<p className="w-full text-center font-breit text-xs font-semibold leading-4 text-card-foreground">{label}</p>
		</div>
	);

	if (to) {
		return (
			<Link to={to} className="block" params={params}>
				{content}
			</Link>
		);
	}

	if (!onClick) {
		return content;
	}

	return (
		<button type="button" onClick={onClick} className="text-left">
			{content}
		</button>
	);
};
